import axios from '../../axios'

export const getInvestors = async (filter) => {
  try {
    const response = await axios.get(`/v1/investors`, {
      params: filter,
    })

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getInvestor = async (id) => {
  try {
    const response = await axios.get(`/v1/investors/${id}`)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const updateInvestor = async (id, investor) => {
  try {
    const response = await axios.patch(`/v1/investors/${id}`, investor)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const creditChargeManual = async (investor) => {
  try {
    const response = await axios.post(
      '/v1/investors/credit-inc-manual',
      investor
    )

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const creditRejectReceipt = async (investor) => {
  try {
    const response = await axios.post('/v1/investors/credit-reject', investor)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getRequestInvest = async () => {
  try {
    const response = await axios.get(
      '/v1/request-invest/startup-request-invest'
    )

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getRequestInvestByStartupId = async (startupId) => {
  try {
    const response = await axios.get(
      `/v1/request-invest/startup-request-invest/${startupId}`
    )

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getRequestInvestByInvestorId = async (investorId) => {
  try {
    const response = await axios.get(
      `/v1/request-invest/investor-request-invest/${investorId}`
    )

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const changeRequestInvest = async (id, data) => {
  try {
    const response = await axios.patch(`/v1/request-invest/${id}`, data)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getInvoicesByAdmin = async (params) => {
  try {
    const response = await axios.get('/v1/investors/invoices-by-admin', {
      params,
    })

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const confirmReceipt = async (invoiceId) => {
  try {
    const response = await axios.post('/v1/invoices/confirm/receipt', {
      invoiceId,
    })

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const rejectReceipt = async (invoiceId) => {
  try {
    const response = await axios.post('/v1/invoices/reject/receipt', {
      invoiceId,
    })

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const createTicket = async (ticket) => {
  try {
    const response = await axios.post('/v1/admin/tickets', ticket)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const updateInvestorStatus = async (id, value) => {
  try {
    const response = await axios.put(
      `/v1/admin/investor-verifications/${id}/status`,
      value
    )

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getReceiptInvoices = async (id) => {
  try {
    const response = await axios.get(`/v1/investors/receipt-invoices/${id}`)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getInvestorManagers = async () => {
  try {
    const response = await axios.get('/v1/admin/investor-managers')

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}
